import { Repeat, Wallet, AlertCircle, CalendarClock } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const cards = [
  { icon: Repeat, title: "Frequent Shaving", copy: "The stubble returns within days — so the routine never really ends." },
  { icon: Wallet, title: "Repeated Waxing Expenses", copy: "Monthly appointments add up to a significant cost over the years." },
  { icon: AlertCircle, title: "Razor Bumps & Irritation", copy: "Friction and ingrown hair can leave underarms sore and darkened." },
  { icon: CalendarClock, title: "Constant Maintenance", copy: "Temporary methods demand your time, planning and attention — forever." },
];

export const Problem = () => (
  <section data-testid="problem-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead
        index="01"
        eyebrow="The Problem"
        title="Still Shaving, Waxing or Dealing With Underarm Bumps?"
        copy="Temporary hair-removal methods need to be repeated again and again. Laser hair reduction works by targeting the hair follicle to progressively reduce unwanted hair growth over multiple sessions."
      />
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08}>
            <div
              data-testid={`problem-card-${i + 1}`}
              className="group h-full rounded-3xl border border-champagne/60 bg-white/60 p-8 transition-[background-color,border-color,transform] duration-500 hover:-translate-y-1.5 hover:bg-white hover:border-champagne"
            >
              <c.icon className="w-7 h-7 text-teal transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-xl md:text-2xl font-medium tracking-tight text-ink">{c.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-ink/60">{c.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
